export const validateJambScore = (totalScore, firstScore, secondScore, thirdScore, fourthScore) => {

  return (Number(firstScore) + Number(secondScore) + Number(thirdScore) + Number(fourthScore)) === Number(totalScore);

}

export const validateAge = (dob) => {

  const CURRENT_YEAR = new Date().getFullYear();

  const BIRTH_YEAR = new Date(dob).getFullYear()

  return (CURRENT_YEAR - BIRTH_YEAR) > 13;

}

export const validateEmail = (email) => {

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email).trim());

}

export const validateJambNumber = (jambNumber) => {

  return /^\d{12}[A-Za-z]{2}$/.test(String(jambNumber).trim());

}
